import React from "react"

import { inject, observer } from "mobx-react"
import { PropTypes } from "prop-types"

import Logo from "../../../images/logo.svg"
import England from "../../../images/icons/england.svg"
import Wales from "../../../images/icons/wales.svg"
import Scotland from "../../../images/icons/scotland.svg"

import "./sample-letter-print.scss"

export const SampleLetterPrint = inject("regionStore")(
  observer(
    ({ regionStore, title, instructions, isRelevantToCurrentRegion }) => (
      <div className="d-none d-print-block sample-letter-print">
        <div className="d-flex justify-content-between">
          <img src={Logo} alt="" className="sample-letter-print-logo" />

          <div className="sample-letter-print-flags d-flex justify-content-end flex-wrap">
            <p className="text-right w-100 mb-2">
              <strong>
                This letter is&nbsp;
                {!isRelevantToCurrentRegion && (
                  <span className="text-danger">not&nbsp;</span>
                )}
                relevant in&nbsp;
                {regionStore.currentRegionData.label}.
              </strong>
            </p>

            {regionStore.isEngland ? (
              <>
                <img
                  src={England}
                  className="sample-letter-print-flags-flag"
                  alt=""
                />
                <img
                  src={Wales}
                  className="sample-letter-print-flags-flag"
                  alt=""
                />
              </>
            ) : (
              <img
                src={Scotland}
                className="sample-letter-print-flags-flag"
                alt=""
              />
            )}
          </div>
        </div>

        <h2 className="mt-5">{title}</h2>

        <div className="card background-print">
          <div className="card-body pb-0">
            <p>{instructions}</p>
          </div>
        </div>
      </div>
    )
  )
)

SampleLetterPrint.propTypes = {
  title: PropTypes.string,
  instructions: PropTypes.string,
  isRelevantToCurrentRegion: PropTypes.bool,
}
